module.exports = __webpack_public_path__ + "img/button_on.9d006799.png";